import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Site } from './site.model';

export enum SiteActionTypes {
  LoadSites = '[Site] Load Sites',
  AddSite = '[Site] Add Site',
  UpsertSite = '[Site] Upsert Site',
  AddSites = '[Site] Add Sites',
  UpsertSites = '[Site] Upsert Sites',
  UpdateSite = '[Site] Update Site',
  UpdateSites = '[Site] Update Sites',
  DeleteSite = '[Site] Delete Site',
  DeleteSites = '[Site] Delete Sites',
  ClearSites = '[Site] Clear Sites',
}

export class LoadSites implements Action {
  readonly type = SiteActionTypes.LoadSites;

  constructor(public payload: { sites: Site[] }) {}
}

export class AddSite implements Action {
  readonly type = SiteActionTypes.AddSite;

  constructor(public payload: { site: Site }) {}
}

export class UpsertSite implements Action {
  readonly type = SiteActionTypes.UpsertSite;

  constructor(public payload: { site: Site }) {}
}

export class AddSites implements Action {
  readonly type = SiteActionTypes.AddSites;

  constructor(public payload: { sites: Site[] }) {}
}

export class UpsertSites implements Action {
  readonly type = SiteActionTypes.UpsertSites;

  constructor(public payload: { sites: Site[] }) {}
}

export class UpdateSite implements Action {
  readonly type = SiteActionTypes.UpdateSite;

  constructor(public payload: { site: Update<Site> }) {}
}

export class UpdateSites implements Action {
  readonly type = SiteActionTypes.UpdateSites;

  constructor(public payload: { sites: Update<Site>[] }) {}
}

export class DeleteSite implements Action {
  readonly type = SiteActionTypes.DeleteSite;
  constructor(public payload: { id: string }) {}
}

export class DeleteSites implements Action {
  readonly type = SiteActionTypes.DeleteSites;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearSites implements Action {
  readonly type = SiteActionTypes.ClearSites;
}

export type SiteActions =
  | LoadSites
  | AddSite
  | UpsertSite
  | AddSites
  | UpsertSites
  | UpdateSite
  | UpdateSites
  | DeleteSite
  | DeleteSites
  | ClearSites;
